import moment, {Duration, duration, Moment} from 'moment'
import {formatServerTime} from '../formatters/formatServerTime'

export function fromServerTimeToMoment(time: string): Moment {
    return moment(time, 'HH:mm:ss')
}

export function fromServerTimeToDuration(time: string): Duration {
    return duration(time)
}

export function fromDateAndTimeToMoment(date: string, hour: string, minute: string): Moment {
    return moment(`${date}T${formatServerTime(hour, minute)}`)
}

export function fromTimeToMoment(hour: string, minute: string): Moment {
    return moment(`${hour}:${minute}`, 'H:m')
}
